var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRteBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rich-text-updates",
    transform: "translate(-501.000000, -116.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-bold",
    transform: "translate(501.000000, 116.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.97190476,7.29363636 C9.97190476,7.80090909 9.86047619,8.23 9.63571429,8.57909091 C9.41190476,8.93 9.09095238,9.20545455 8.67285714,9.40863636 C8.22904762,9.62363636 7.71904762,9.77727273 7.14095238,9.86681818 C6.56238095,9.95545455 6.35809524,10 5.5752381,10 L0,10 L0,9.18909091 C0.152380952,9.17636364 0.967142857,8.99772727 0.967142857,8.30136364 L0.967142857,1.84227273 C0.967142857,0.998636364 0.152380952,0.899545455 0,0.876818182 L0,0 L5.69190476,0 C7.12428571,0 7.4247619,0.188181818 8.06,0.563181818 C8.6952381,0.94 9.01238095,1.49409091 9.01238095,2.22681818 C9.01238095,3.63 7.83666667,4.46727273 7.45285714,4.55227273 L7.45285714,4.68590909 C7.83666667,4.72363636 9.97190476,5.11818182 9.97190476,7.29363636 Z M6.39714286,2.64727273 C6.39714286,2.23318182 6.23333333,1.90954545 5.90619048,1.67818182 C5.57904762,1.44409091 5.19761905,1.32863636 4.54333333,1.32863636 C4.45,1.32863636 4.32809524,1.33181818 4.17857143,1.33681818 C4.02809524,1.34227273 3.89857143,1.34681818 3.79047619,1.35 L3.79047619,4.12363636 L4.17428571,4.12363636 C4.97190476,4.12363636 5.45047619,3.99045455 5.82952381,3.725 C6.20714286,3.46 6.39714286,3.10136364 6.39714286,2.64727273 Z M6.7847619,7.03409091 C6.7847619,6.50454545 6.57761905,6.09727273 6.16142857,5.815 C5.74666667,5.53181818 5.2552381,5.39045455 4.47619048,5.39045455 C4.38666667,5.39045455 4.26761905,5.39318182 4.11904762,5.39863636 C3.97095238,5.405 3.86095238,5.40863636 3.79,5.41181818 L3.79,8.67272727 C3.79,8.67272727 4.57238095,8.67272727 4.88857143,8.67272727 C5.45047619,8.67272727 5.90619048,8.53 6.25809524,8.24318182 C6.60904762,7.95681818 6.7847619,7.55318182 6.7847619,7.03409091 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRteBold);
export default __webpack_public_path__ + "static/media/icon-rte-bold.f4ddc537e512a505b3d7c1660cfd30d4.svg";
export { ForwardRef as ReactComponent };